(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lw-header"]) return;
  try {
    
if(!customElements.get('lw-mobile-menu'))customElements.define('lw-mobile-menu',class extends HTMLElement{
 connectedCallback(){const d=this.querySelector('dialog'),b=this.querySelector('.lw-menu-toggle');this.abort=new AbortController();const signal=this.abort.signal;b.addEventListener('click',()=>{this.querySelector('.lw-subnav').open=true;d.showModal()},{signal});this.querySelector('.lw-menu-close').addEventListener('click',()=>d.close(),{signal});d.addEventListener('click',e=>{const r=d.getBoundingClientRect();if(e.target===d&&(e.clientX>r.right||e.clientX<r.left||e.clientY<r.top||e.clientY>r.bottom))d.close()},{signal});d.addEventListener('close',()=>b.focus(),{signal});}
 disconnectedCallback(){this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
